var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#41479B"
    },
    width: 512,
    height: 512
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFE15A"
    },
    points: "441.379,0 441.379,512 105.931,0 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M211.685,196.751l7.321,21.951l23.139,0.179c1.793,0.014,2.536,2.302,1.094,3.367l-18.614,13.746   l6.98,22.062c0.541,1.709-1.405,3.123-2.864,2.081l-18.825-13.456l-18.825,13.456c-1.458,1.042-3.404-0.371-2.864-2.081   l6.98-22.062l-18.614-13.746c-1.442-1.065-0.699-3.353,1.094-3.367l23.139-0.179l7.321-21.951   C208.713,195.051,211.118,195.051,211.685,196.751z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M169.685,135.469l7.321,21.951l23.139,0.179c1.793,0.014,2.536,2.302,1.094,3.367l-18.614,13.746   l6.98,22.062c0.541,1.709-1.405,3.123-2.864,2.081l-18.825-13.456l-18.825,13.456c-1.458,1.042-3.404-0.371-2.864-2.081   l6.98-22.062l-18.614-13.746c-1.442-1.065-0.699-3.353,1.094-3.367l23.139-0.179l7.321-21.951   C166.713,133.769,169.118,133.769,169.685,135.469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M132.685,73.245l7.321,21.951l23.139,0.179c1.793,0.014,2.536,2.302,1.094,3.367l-18.614,13.746   l6.98,22.062c0.541,1.709-1.405,3.123-2.864,2.081l-18.825-13.456L112.09,136.63c-1.458,1.042-3.404-0.371-2.864-2.081l6.98-22.062   L97.592,98.741c-1.442-1.065-0.699-3.353,1.094-3.367l23.139-0.179l7.321-21.951C129.713,71.544,132.118,71.544,132.685,73.245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M89.854,11.963l7.321,21.951l23.139,0.179c1.793,0.014,2.536,2.302,1.094,3.367l-18.614,13.746   l6.98,22.062c0.541,1.709-1.405,3.123-2.864,2.081L88.084,61.892L69.259,75.348c-1.458,1.042-3.404-0.371-2.864-2.081l6.98-22.062   L54.761,37.46c-1.442-1.065-0.699-3.353,1.094-3.367l23.139-0.179l7.321-21.951C86.882,10.262,89.287,10.262,89.854,11.963z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M369.295,436.259l7.321,21.951l23.139,0.179c1.793,0.014,2.536,2.302,1.094,3.367l-18.614,13.746   l6.98,22.062c0.541,1.709-1.405,3.123-2.864,2.081l-18.825-13.456L348.7,499.644c-1.458,1.042-3.404-0.371-2.864-2.081l6.98-22.062   l-18.614-13.746c-1.442-1.065-0.699-3.353,1.094-3.367l23.139-0.179l7.321-21.951C366.322,434.558,368.728,434.558,369.295,436.259   z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M331.854,376.862l7.321,21.951l23.139,0.179c1.793,0.014,2.536,2.302,1.094,3.367l-18.614,13.746   l6.98,22.062c0.541,1.709-1.405,3.123-2.864,2.081l-18.825-13.456l-18.825,13.456c-1.458,1.042-3.405-0.371-2.864-2.081   l6.98-22.062l-18.614-13.746c-1.442-1.065-0.699-3.353,1.094-3.367l23.139-0.179l7.321-21.951   C328.882,375.162,331.287,375.162,331.854,376.862z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M290.854,316.523l7.321,21.951l23.139,0.179c1.793,0.014,2.536,2.302,1.094,3.367l-18.614,13.746   l6.98,22.062c0.541,1.709-1.405,3.123-2.864,2.081l-18.825-13.456l-18.825,13.456c-1.458,1.042-3.405-0.371-2.864-2.081   l6.98-22.062l-18.614-13.746c-1.442-1.065-0.699-3.353,1.094-3.367l23.139-0.179l7.321-21.951   C287.882,314.823,290.287,314.823,290.854,316.523z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M248.854,257.127l7.321,21.951l23.139,0.179c1.793,0.014,2.536,2.302,1.094,3.367l-18.614,13.746   l6.98,22.062c0.541,1.709-1.405,3.123-2.864,2.081l-18.825-13.456l-18.825,13.456c-1.458,1.042-3.404-0.371-2.864-2.081   l6.98-22.062l-18.614-13.746c-1.442-1.065-0.699-3.353,1.094-3.367l23.139-0.179l7.321-21.951   C245.882,255.426,248.287,255.426,248.854,257.127z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBa);
export default __webpack_public_path__ + "static/media/ba.915ec0485c43177fc5a1002ebbe2c056.svg";
export { ForwardRef as ReactComponent };